import { render, staticRenderFns } from "./anuencia_detalhe.vue?vue&type=template&id=d8cad560&scoped=true"
import script from "./anuencia_detalhe.vue?vue&type=script&lang=js"
export * from "./anuencia_detalhe.vue?vue&type=script&lang=js"
import style0 from "./anuencia_detalhe.vue?vue&type=style&index=0&id=d8cad560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8cad560",
  null
  
)

export default component.exports